module.exports = __webpack_public_path__ + "static/img/138_TO8_1836.fdced0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/138_TO8_1836.jpg
// module id = Ewsh
// module chunks = 0